import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.array.slice";

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  mutation UpdateFinancialMerchantTransactionCategory(\n    $transactionId: ID!\n    $category: FinancialTransactionCategory!\n    $merchantName: String!\n  ) {\n    updateFinancialMerchantTransactionCategory(\n      transactionId: $transactionId\n      category: $category\n      merchantName: $merchantName\n    ) {\n      success\n    }\n  }\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  mutation UpdateFinancialTransactionVisibility($transactionId: ID!, $isHidden: Boolean!) {\n    updateFinancialTransactionVisibility(transactionId: $transactionId, isHidden: $isHidden) {\n      ...FinancialTransactionFragment\n    }\n  }\n  ", "\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  mutation DeleteFinancialTransaction($transactionId: ID!) {\n    deleteFinancialTransaction(transactionId: $transactionId) {\n      success\n    }\n  }\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  mutation CreateFinancialTransaction(\n    $accountId: ID!\n    $amount: Int!\n    $category: FinancialTransactionCategory!\n    $date: DateTime!\n    $description: String\n    $merchantName: String!\n    $type: FinancialTransactionType!\n  ) {\n    createFinancialTransaction(\n      accountId: $accountId\n      amount: $amount\n      category: $category\n      date: $date\n      description: $description\n      merchantName: $merchantName\n      type: $type\n    ) {\n      ...FinancialTransactionFragment\n    }\n  }\n  ", "\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  mutation UpdateFinancialTransaction(\n    $amount: Int!\n    $category: FinancialTransactionCategory!\n    $date: DateTime!\n    $merchantName: String\n    $type: FinancialTransactionType\n    $transactionId: ID!\n  ) {\n    updateFinancialTransaction(\n      amount: $amount\n      category: $category\n      date: $date\n      merchantName: $merchantName\n      type: $type\n      transactionId: $transactionId\n    ) {\n      ...FinancialTransactionFragment\n    }\n  }\n  ", "\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialTransactionById($transactionId: ID!) {\n    financialTransactionById(transactionId: $transactionId) {\n      ...FinancialTransactionFragment\n    }\n  }\n  ", "\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialTransactions(\n    $filter: FinancialTransactionsFilterInput\n    $pagination: AdvancedOffsetPaginationInput\n  ) {\n    financialTransactions(filter: $filter, pagination: $pagination) {\n      pagination {\n        limit\n        offset\n        resultSetToken\n      }\n      transactions {\n        ...FinancialTransactionFragment\n      }\n    }\n  }\n  ", "\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  fragment FinancialTransactionFragment on FinancialTransaction {\n    account {\n      id\n      name\n      mask\n      financialPortal {\n        id\n        marketplaceInstitution {\n          id\n          name\n        }\n      }\n    }\n    amount\n    category\n    currency\n    date\n    description\n    id\n    isHidden\n    isPending\n    merchantName\n    type\n  }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialAccountIAVDetails($financialAccountIds: [ID!]!) {\n    financialAccountsIAVDetails(financialAccountIds: $financialAccountIds) {\n      details {\n        accountNumber\n        holderNames\n        routingNumber\n      }\n    }\n  }\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  mutation DeleteFinancialPortal($financialPortalId: ID!) {\n    deleteFinancialPortal(financialPortalId: $financialPortalId) {\n      success\n    }\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  mutation NotifyPlaidLinkEvent(\n    $event: ProxyEventType!\n    $eventBody: JSON\n    $financialPortalId: ID\n    $isMigrate: Boolean\n    $marketplaceInstitutionId: ID\n    $source: FinancialDataSource\n    $sourceEntityId: ID\n    $sourceInstitutionId: ID\n  ) {\n    publishFinancialDataLinkEvent(\n      event: $event\n      eventBody: $eventBody\n      financialPortalId: $financialPortalId\n      isMigrate: $isMigrate\n      migrationMarketplaceInstitutionId: $marketplaceInstitutionId\n      source: $source\n      sourceEntityId: $sourceEntityId\n      sourceInstitutionId: $sourceInstitutionId\n    ) {\n      success\n    }\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialDataProfileForUser {\n    ...FinancialAccountsForUserFragment\n    ...LinkedFinancialPortalsForUserFragment\n    ...FinancialAccountTypeSumsFragment\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialAccountsByPortal($financialPortalId: ID!) {\n    financialAccountsByPortal(financialPortalId: $financialPortalId) {\n      accounts {\n        ...FinancialAccountFragment\n      }\n    }\n  }\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  mutation ReinitializeFinancialPortalMutation($financialPortalId: ID!) {\n    reinitializeFinancialPortal(financialPortalId: $financialPortalId) {\n      details {\n        publicToken\n        recommendedInstitutionId\n        recommendedSourceInstitutionId\n      }\n      financialPortal {\n        id\n        primaryClientAction\n      }\n    }\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  mutation RefreshFinancialPortalMutation($financialPortalId: ID!, $isAutoRefresh: Boolean) {\n    refreshFinancialPortal(financialPortalId: $financialPortalId, isAutoRefresh: $isAutoRefresh) {\n      ...FinancialPortalFragment\n    }\n  }\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  query GetLinkedFinancialPortals {\n    ...LinkedFinancialPortalsForUserFragment\n  }\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialPortals {\n    ...FinancialPortalsForUserFragment\n  }\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  mutation FinishPortalMigration($portalId: ID!, $shouldMigrate: Boolean) {\n    finishPortalMigration(financialPortalId: $portalId, shouldMigrate: $shouldMigrate) {\n      portal {\n        id\n        migrationDetails {\n          hasUserConfirmed\n        }\n        primarySource\n      }\n    }\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  query GetPortalByIdWithMigrationDetails($portalId: ID!) {\n    financialPortalById(financialPortalId: $portalId) {\n      id\n      migrationDetails {\n        accountsMapping\n        newAccountIds\n        oldAccountIds\n        recommendedMarketplaceInstitutionId\n      }\n    }\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  query GetPortalByInstitutionId($marketplaceInstitutionId: ID!) {\n    financialPortalByInstitutionId(marketplaceInstitutionId: $marketplaceInstitutionId) {\n      id\n      errorMessage\n      marketplaceInstitution {\n        aggregatorType\n        externalId\n        id\n        loginUrl\n        logoUrl\n        name\n      }\n      primaryClientAction\n      primarySource\n      sourceEntityId\n      sourceInstitutionId\n    }\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  mutation UpdateFinancialAccountVisibility($financialAccountId: ID!, $isHidden: Boolean!) {\n    updateFinancialAccountVisibility(financialAccountId: $financialAccountId, isHidden: $isHidden) {\n      id\n      isHidden\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  fragment FinancialAccountTypeSumsFragment on Query {\n    financialAccountTypeSums {\n      assets\n      banks\n      bills\n      creditCards\n      debts\n      investments\n      loans\n      other\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  query getFinancialAccounts {\n    ...FinancialAccountsForUserFragment\n  }\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  fragment LinkedFinancialPortalsForUserFragment on Query {\n    linkedFinancialPortals {\n      portals {\n        ...FinancialPortalFragment\n      }\n    }\n  }\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  fragment FinancialPortalsForUserFragment on Query {\n    financialPortals {\n      portals {\n        ...FinancialPortalFragment\n      }\n    }\n  }\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  fragment FinancialAccountsForUserFragment on Query {\n    financialAccounts {\n      accounts {\n        ...FinancialAccountFragment\n      }\n    }\n  }\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fragment FinancialPortalFragment on FinancialPortal {\n    createdAt\n    id\n    identityId\n    primarySource\n    sequenceNumber\n    source\n    sourceEntityId\n    updatedAt\n    accountsState\n    activeMigration\n    authState\n    authStateSetAt\n    canonicalInstitutionId\n    errorMessage\n    errorName\n    errorPriority\n    isActiveSync\n    isAutoRefreshing\n    isBalanceRefreshing\n    isManualRefreshing\n    isRefreshing\n    lastRefreshedAt\n    migrationDetails {\n      hasUserConfirmed\n    }\n    marketplaceInstitution {\n      id\n      name\n      loginUrl\n      logoUrl\n      iavEnabled\n      iavAdminDeactivated\n      externalId\n      aggregatorType\n    }\n    primaryClientAction\n    sourceInstitutionId\n    transactionsState\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment FinancialAccountFragment on FinancialAccount {\n    autoRefreshRequired\n    balance\n    createdAt\n    currency\n    extra\n    financialPortal {\n      accountsState\n      activeMigration\n      authState\n      authStateSetAt\n      canonicalInstitutionId\n      createdAt\n      errorMessage\n      errorName\n      errorPriority\n      id\n      identityId\n      isActiveSync\n      isAutoRefreshing\n      isBalanceRefreshing\n      isManualRefreshing\n      lastRefreshedAt\n      marketplaceInstitution {\n        iavAdminDeactivated\n        iavEnabled\n        id\n        loginUrl\n        logoUrl\n        name\n      }\n      primarySource\n      sequenceNumber\n      source\n      sourceEntityId\n      sourceInstitutionId\n      transactionsState\n      updatedAt\n    }\n    iavVerified\n    id\n    isHidden\n    lastSyncedAt\n    mask\n    name\n    primarySource\n    status\n    subtype\n    subtypeDetails\n    transactionsSyncedAt\n    type\n    updatedAt\n    verificationState\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { gql } from '@nerdwallet/apollo';
var financialAccountFragment = gql(_templateObject());
var financialPortalFragment = gql(_templateObject2());
export var financialAccountsForUserFragment = gql(_templateObject3(), financialAccountFragment);
export var financialPortalsForUserFragment = gql(_templateObject4(), financialPortalFragment);
export var linkedFinancialPortalsForUserFragment = gql(_templateObject5(), financialPortalFragment);
export var GET_ACCOUNTS_FOR_USER_QUERY = gql(_templateObject6(), financialAccountsForUserFragment);
export var financialAccountTypeSumsFragment = gql(_templateObject7());
export var UPDATE_FINANCIAL_ACCOUNT_VISIBILITY = gql(_templateObject8());
export var GET_PORTAL_BY_INSTITUTION_ID_QUERY = gql(_templateObject9());
export var GET_PORTAL_BY_ID_WITH_MIGRATION_DETAILS_QUERY = gql(_templateObject10());
export var FINISH_PORTAL_MIGRATION_MUTATION = gql(_templateObject11());
export var GET_PORTALS_FOR_USER_QUERY = gql(_templateObject12(), financialPortalsForUserFragment);
export var GET_LINKED_PORTALS_FUR_USER_QUERY = gql(_templateObject13(), linkedFinancialPortalsForUserFragment);
export var REFRESH_FINANCIAL_PORTAL_MUTATION = gql(_templateObject14(), financialPortalFragment);
export var REINITIALIZE_FINANCIAL_PORTAL_MUTATION = gql(_templateObject15());
export var GET_FINANCIAL_ACCOUNTS_BY_PORTAL = gql(_templateObject16(), financialAccountFragment);
export var GET_FINANCIAL_DATA_PROFILE_FOR_USER = gql(_templateObject17(), financialAccountsForUserFragment, linkedFinancialPortalsForUserFragment, financialAccountTypeSumsFragment);
export var NOTIFY_PLAID_LINK_EVENT_MUTATION = gql(_templateObject18());
export var DELETE_FINANCIAL_PORTAL = gql(_templateObject19());
export var GET_FINANCIAL_ACCOUNT_IAV_DETAILS = gql(_templateObject20());
var financialTransactionFragment = gql(_templateObject21());
export var GET_TRANSACTIONS_FOR_USER_QUERY = gql(_templateObject22(), financialTransactionFragment);
export var GET_TRANSACTION_FOR_USER_BY_ID_QUERY = gql(_templateObject23(), financialTransactionFragment);
export var UPDATE_FINANCIAL_TRANSACTION = gql(_templateObject24(), financialTransactionFragment);
export var CREATE_FINANCIAL_TRANSACTION = gql(_templateObject25(), financialTransactionFragment);
export var DELETE_FINANCIAL_TRANSACTION = gql(_templateObject26());
export var UPDATE_FINANCIAL_TRANSACTION_VISIBILITY = gql(_templateObject27(), financialTransactionFragment);
export var UPDATE_FINANCIAL_MERCHANT_TRANSACTION_CATEGORY = gql(_templateObject28());